import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";

export default function ProductsSolutions() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };
  return (
    <div className=" bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/solutionscard.png"
          alt="Solutions"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">
          {" "}
          Solutions
        </div>
      </div>
      <div>
        <p className="fs-5 mt-3">
          Solutions are ready to use workflows designed to manage business
          process and communications workflows.
        </p>
        <p className="fs-5 ">
          {" "}
          Boomerang has curated a selection of ready-to-deploy solutions that
          simply need completing before they are ready for use.{" "}
        </p>
        <p className="fs-5 ">
          {" "}
          We have done the hard work of building, rigorously testing and
          publishing each solution. All you need to do is select the one that is
          right for you, complete the guided form with a few simple inputs, and
          once tested, publish the solution.{" "}
        </p>
        <p className="fs-5 ">
          Selected a solution but it is not quite right? No problem. Let us know
          and we can republish it with the required changes.
        </p>
        <p className="fs-5 ">
          Don’t see a solution for the process you need? Not a problem.
        </p>{" "}
        <p className="fs-5 ">
          Let us know, describe the requirement, and we will build it for you.
          <p className="fs-5 ">
            We have invested in a no-code environment that allows us to build
            solutions quickly and efficiently, ensuring nothing becomes a
            barrier.
          </p>
          Listed below are just some of the capabilities that our Solutions have
          access to:
        </p>
      </div>
      <div>
        <p className="fs-5 ">
          {" "}
          <span className="fw-bold">Lone worker</span> – fulfil your
          organisations duty of care and provide a lone worker solution without
          the need for an App and all of it negative connotations
        </p>
        <p className="fs-5 ">
          <span className="fw-bold">Weather alerts</span> – Create manage and
          escalate weather alerts by area, weather type and weather conditions.
        </p>
        <p className="fs-5 ">
          <span className="fw-bold">Monitoring</span> – Create monitors to react
          to specific warnings, failings and outages by location, machine or
          event and create the communications and alerting workflow specific for
          each{" "}
        </p>
      </div>
      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
